module.exports = __webpack_public_path__ + "img/EvolutionSystem.ccb8605c.png";